module.exports = __webpack_public_path__ + "static/media/shengdiao017.d2eed6fd.jpg";